const err = (message) => ({ type: 'manual', message }); // For react-hook-form

const validateForm = (values) => {
  const errors = {};

  // GDPR validation
  const gdpr = values.gdpr || {};
  if (gdpr.hasPersonalDetails !== true && gdpr.hasPersonalDetails !== false) {
    errors.gdpr = { ...(errors.gdpr || {}), hasPersonalDetails: err('Välj ett alternativ') };
  }

  if (gdpr.hasPersonalDetails === true) {
    const gdprErrors = {};
    if (!gdpr.type) gdprErrors.type = err('Typ av uppgift måste anges');
    if (!gdpr.purpose) gdprErrors.purpose = err('Syfte måste anges');
    if (!gdpr.noOfEntities) gdprErrors.noOfEntities = err('Antal poster måste anges');
    if (!gdpr.description) gdprErrors.description = err('Uppdragsbeskrivning måste anges');

    if (Object.keys(gdprErrors).length > 0) {
      errors.gdpr = { ...(errors.gdpr || {}), ...gdprErrors };
    }
  }

  // File drop validation
  if (!values.fileDrop || !values.fileDrop.length) {
    errors.fileDrop = err('Minst en leveransfil måste bifogas');
  } 

  // Recipients validation
  if (!values.recipients || !values.recipients.length) {
    errors.recipients = err('Minst en mottagare av leveransen måste existera');
  } else {
    const recipientsArrayErrors = [];

    values.recipients.forEach((recipient, recipientIndex) => {
      const recipientErrors = {};

      if (!recipient || !recipient.firstName) {
        recipientErrors.firstName = err('Förnamn måste anges');
      }

      if (!recipient || !recipient.lastName) {
        recipientErrors.lastName = err('Efternamn måste anges');
      }

      if (!recipient || !recipient.email) {
        recipientErrors.email = err('E-postadress måste anges');
      } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,8}$/i.test(recipient.email)) {
        recipientErrors.email = err('Ogiltigt format på e-postadress');
      }

      if (!recipient || !recipient.cell) {
        recipientErrors.cell = err('Mobilnummer måste anges för leveranser');
      }

      if (!recipient || !recipient.companyName) {
        recipientErrors.companyName = err('Företagsnamn måste anges');
      }

      if (recipient?.organizationNo && !/^[0-9\d]{6}[-—\D]{1}[0-9\d]{4}|[0-9\d]{10}$/i.test(recipient.organizationNo)) {
        recipientErrors.organizationNo = err('Ogiltigt format på Organisationsnummer');
      }

      if (Object.keys(recipientErrors).length > 0) {
        recipientsArrayErrors[recipientIndex] = recipientErrors;
      }
    });

    if (recipientsArrayErrors.length > 0) {
      errors.recipients = recipientsArrayErrors;
    }
  }

  // Delivery message validation
  if (!values.deliveryMessage) {
    errors.deliveryMessage = err('Ett leveransmeddelande måste anges');
  }

  // Suppliers validation
  if (values.selectedSuppliers && values.selectedSuppliers.length > 0) {
    const selectedSuppliersArrayErrors = [];
  
    values.selectedSuppliers.forEach((supplier, supplierIndex) => {
      const supplierErrors = {};
  
      if (!supplier || !supplier.description) {
        supplierErrors.description = err('En beskrivning måste anges');
      }

      if (Object.keys(supplierErrors).length > 0) {
        selectedSuppliersArrayErrors[supplierIndex] = supplierErrors;
      }
    });
  
    if (selectedSuppliersArrayErrors.length > 0) {
      errors.selectedSuppliers = selectedSuppliersArrayErrors;
    }
  }

  return errors;
};

export { validateForm };
